import { redirect } from 'react-router';

import { getOrganisation } from '@/domain/organisation/actions/get-organisation.action';
import { selectIsOrganisationSet } from '@/domain/organisation/organisation.selectors';
import { store } from '@/domain/store';
import { getTags } from '@/domain/tags/actions/get-tags.action.ts';
import { prepareAuth } from '@/ui/navigation/loaders/prepare-auth-loader';

/**
 * Do nothing if user is connected
 * Open create organisation page if not set
 * Load data needed (userInfos, projects...)
 */
export async function appIndexLoader() {
  const { userIsConnected } = await prepareAuth();
  if (!userIsConnected) {
    return null;
  }
  try {
    await store.dispatch(getOrganisation()).unwrap();
  } catch (error) {
    console.error(error);
  }
  const isOrganisationSet = selectIsOrganisationSet(store.getState());
  if (isOrganisationSet) {
    return redirect('/app/projects');
  } else {
    return redirect('/app/create-organisation');
  }
}

/**
 * Load data needed on lot of pages
 * getUserInfos() is called in prepareAuth()
 */
export async function makeCommonGets() {
  store.dispatch(getOrganisation());
  store.dispatch(getTags());
}
